import p5 from "p5";
import { Compare, GameModel } from "./GameModel";
import { GameView } from "./GameView";
import { ViewHello } from "../views/ViewHello";
import { ViewAskForNumber, ViewAskForNumberData } from "../views/ViewAskForNumber";
import { ViewWon } from "../views/ViewWon";
import { ViewMyNumberIsHigher } from "../views/ViewMyNumberIsHigher";
import { ViewMyNumberIsLower } from "../views/ViewMyNumberIsLower";
import { ViewNewNumber } from "../views/ViewNewNumber";

export class GameController {
    public constructor(public p: p5, public model: GameModel, public view: GameView) {

    }

    public draw() {
        this.view.draw();
    }

    public start() {
        this.view.set_view(new ViewHello(this.p, this));
    }

    public new_number() {
        this.model.reset();
        this.view.set_view(new ViewNewNumber(this.p, this));
    }

    public ask_for_number() {
        const data: ViewAskForNumberData = {
            current_guess: this.model.guessing_input
        };
        this.view.set_view(new ViewAskForNumber(this.p, this, data));
    }

    public check_if_number_is_correct() {
        const comparison = this.model.compare_numbers();
        this.model.reset_guess();
        switch (comparison) {
            case Compare.EQUAL:
                this.view.set_view(new ViewWon(this.p, this));
                this.model.reset();
                break;
            case Compare.HIGHER:
                this.view.set_view(new ViewMyNumberIsHigher(this.p, this));
                break;
            case Compare.LOWER:
                this.view.set_view(new ViewMyNumberIsLower(this.p, this));
                break;
        }
    }

    public add_digit_to_number(digit: number) {
        this.model.add_digit(digit);
    }

    public reset_guess() {
        this.model.reset_guess();
    }

    public delete_digit() {
        this.model.remove_digit();
    }
}